import { useNavbarConfig } from '@features/navbar/hooks/use-navbar-config';
import { useEffect } from 'react';

export function AppThemeColorProvider({
  children,
}: {
  children?: React.ReactNode;
}) {
  const { backgroundColor } = useNavbarConfig();

  useEffect(() => {
    const themeColorMetaTag = document.querySelector(
      'meta[name="theme-color"]',
    );

    if (themeColorMetaTag) {
      themeColorMetaTag.setAttribute('content', backgroundColor);
    } else {
      const newMetaTag = document.createElement('meta');

      newMetaTag.name = 'theme-color';
      newMetaTag.content = backgroundColor;

      document.head.appendChild(newMetaTag);
    }
  }, [backgroundColor]);

  return children;
}
